<template>
<div :class="(showMessageBar?'':'d-none') + '  message-bar'">
  <div :class="messageClass">
    <div class="row m-0 align-items-center">
      <div>
        {{ currentMessage }}
      </div>
      <div class="text-right" @click="closeMessageBar">
        <ios-close-icon />
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  mapActions,
  mapGetters
} from 'vuex'
export default {
  computed: {
    ...mapGetters(['messages']),
    showMessageBar () {
      return this.messages.message && this.messages.message.length > 0
    },
    messageClass () {
      let mgClass = this.messages.messageClass
      return 'col-12 panel panel-' + mgClass + ' ' + (this.showMessageBar ? '' : 'hidden')
    },
    currentMessage () {
      return this.messages.message
    }
  },
  methods: {
    ...mapActions(['clearMessage']),
    closeMessageBar () {
      this.clearMessage()
    }
  }
}
</script>

<style scoped>
.message-bar {
  position: fixed;
  bottom: 0;
  right: 0;
  width: auto;
  min-height: 50px;
  z-index: 9999;
  background-color: var(--dark-color);
}
.dark-mode .message-bar {
  background-color: var(--light-color);
  font-weight: 400;
}
.message-bar .close-btn {
  position: absolute;
  top: 0;
  right: 0;
  color: #FFF;
}

.message-bar .panel {
  border-color: transparent;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  padding-right: 25px;
}

.panel {
  padding: 10px 15px;
}

.panel-danger {
  color: var(--red-color);
  background-color: transparent;
}
.panel-success {
  background-color: transparent;
  color: var(--green-color);
}
.panel-warning {
  background-color: transparent;
  color: #f0ad4e;
}
.text-right {
  color: var(--light-color)
}
.dark-mode .text-right {
  color: var(--dark-color)
}
@media (min-width: 768px) {
  .message-bar {
    position: fixed;
    top: 0;
    bottom: inherit;
    right: 0;
    width: auto;
    min-height: 50px;
    z-index: 9999;
    background-color: var(--dark-color);
  }
}
</style>
